import styled from 'styled-components'
import Close from "../../Icons/Close";

export const Wrap = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: ${(props) => props.theme.colors.bg};
  overflow-y: scroll;
  display: block;
`;

export const StyledClose = styled(Close)`
  svg {
    fill: ${(props) => props.theme.colors.close};
  }
`;

export const Image = styled.img`
  max-width: 100%;
`;
